<template>
  <div
    class="modal fade"
    id="vrbo-user-connection-modal"
    aria-hidden="true"
    aria-labelledby="exampleGrid"
    role="dialog"
  >
    <div class="modal-dialog modal-simple modal-center">
      <div class="modal-content">
        <form autocomplete="off">
          <div class="modal-header">
            <div class="container">
              <div class="row header">
                <div class="col-8">
                  <h4 class="modal-title">
                    {{ $t("rentals.detail.platforms.vrbo.vrbo") }}
                  </h4>
                </div>
                <div class="col-4">
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    @click.prevent="closeVrboUserConnectionModal()"
                  >
                    <span aria-hidden="true" class="close-btn">&times;</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-body">
            <!-- dis/connect vrbo -->
            <div class="row">
              <div class="form-group form-material col-12">
                <label for="booking-room-id" class="control-label">
                  {{
                    user.vrbo_account && user.vrbo_account.active
                      ? $t("rentals.detail.platforms.vrbo.disable_vrbo")
                      : $t("rentals.detail.platforms.vrbo.enable_vrbo")
                  }}
                </label>
                <div
                  class="auto auto-onOff pull-right m-r-50 m-t-15"
                  @click="updateVrboUserConnection()"
                >
                  <switches
                    v-model="isVrboUserActive"
                    theme="bulma"
                    color="blue"
                    type-bold="false"
                  >
                  </switches>
                </div>
              </div>
            </div>
            <!-- advertiser id -->
            <div class="row">
              <div class="form-group form-material col-12">
                <label for="booking-room-id" class="control-label">
                  {{ $t("rentals.detail.platforms.vrbo.advertiser_id_label") }}
                </label>
                <div class="auto auto-onOff pull-right m-r-50 m-t-15">
                  {{
                    user.vrbo_account && user.vrbo_account.active
                      ? user.vrbo_account.vrbo_advertiser_id
                      : ""
                  }}
                </div>
              </div>
            </div>
          </div>

          <v-loading
            :isLoading="smallLoading"
            :height="50"
            :width="50"
            :viewbox="'0 0 50 50'"
            :cx="25"
            :cy="25"
            :r="22"
            :isHeightAuto="true"
          ></v-loading>
          <div class="modal-footer text-center">
            <button
              type="button"
              class="btn waves-effect waves-classic btn-cancel"
              @click.prevent="closeVrboUserConnectionModal()"
              data-dismiss="modal"
              :disabled="smallLoading"
            >
              {{ $t("button.cancel") }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from "../../../../mixins/mixin";
import vrboService from "../../../../services/vrbo";
import Switches from "vue-switches";

export default {
  name: "VrboUserConnectionModal",

  props: ["user", "fetchAccount"],

  data() {
    return {
      smallLoading: false,
    };
  },

  components: {
    VLoading: require("components/loading/loading.vue"),
    Switches,
  },

  mixins: [mixin],

  mounted() {},

  computed: {
    isVrboUserActive: {
      // return this.user.vrbo_account ? this.user.vrbo_account.active : false;
      get() {
        return this.user.vrbo_account ? this.user.vrbo_account.active : false;
      },
      set(value) {
        if (this.user.vrbo_account) {
          this.user.vrbo_account.active = value;
        }
      }
    },
  },

  methods: {
    async updateVrboUserConnection() {
      this.smallLoading = true;

      if (this.user.vrbo_account && this.user.vrbo_account.active) {
        await vrboService.vrboDisconnectUser(this, null, this.user.id);
      } else {
        await vrboService.vrboConnectUser(this, null, this.user.id);
      }

      await this.fetchAccount();

      this.smallLoading = false;
    },

    closeVrboUserConnectionModal() {
      this.closeModal("#vrbo-user-connection-modal");
    },
  },
};
</script>



// WEBPACK FOOTER //
// VrboUserConnectionModal.vue?3c15e57e